<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="monitoring && monitoring.atribut_id ? 'Ubah Atribut':'Tambah Atribut'"
  >
    <v-container>
      <v-form @submit.prevent data-vv-scope="form" lazy-validation>
        <v-row row wrap justify="center" align="center">
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="py-0">
            <label class="caption mb-2">Label Atribut</label>
            <v-text-field
              autofocus
              dense
              single-line
              outlined
              label="Label Atribut"
              v-model="monitoring.nama"
              persistent-hint
              hint="Label Atribut Yang Digunakan Akan Muncul Saat Tambah Anggota Baru. Contoh: Pendidikan Terakhir"
              data-vv-name="monitoring"
              data-vv-as="Label Atribut"
              v-validate="'required'"
              :error-messages="errors.collect('form.monitoring')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="py-0">
            <label class="caption mb-2">Tipe</label>
            <v-select
              dense
              single-line
              outlined
              :items="types"
              v-model="monitoring.tipe"
              label="Tipe"
              data-vv-name="tipe"
              data-vv-as="Tipe"
              v-validate="'required'"
              :error-messages="errors.collect('form.tipe')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="8"
            lg="8"
            xl="8"
            v-if="monitoring.tipe=='Teks' || monitoring.tipe=='Angka'"
            class="py-0"
          >
            <label class="caption mb-2">Isian Umum</label>
            <v-text-field
              dense
              single-line
              outlined
              label="Isian Umum"
              v-model="monitoring.default_value"
              hint="Isian Umum dari Atribut yang dibuat"
              data-vv-name="default_value"
              data-vv-as="Isian Umum"
              v-validate="'required'"
              :error-messages="errors.collect('form.default_value')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8">
            <div v-if="monitoring.tipe=='Pilihan'">
              <v-alert
                text
                dense
                color="blue"
                icon="mdi-information-outline"
                border="left"
              >Masukkan Pilihan {{monitoring.nama}}</v-alert>
              <div v-for="(item,index) in jumlahAtribut" :key="item">
                <v-row wrap>
                  <v-col cols="10" class="py-0">
                    <label class="caption mb-2">Pilihan</label>
                    <v-text-field
                      dense
                      single-line
                      outlined
                      label="Pilihan"
                      hint="Masukkan Pilihan"
                      v-model="arrayAtribut[index]"
                      data-vv-name="default_value"
                      data-vv-as="default_value"
                      v-validate="'required'"
                      @keyup.enter="add"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn depressed fab color="red" small @click="remove(index)">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-btn depressed fab small color="blue" @click="add">
                <span class="white--text">
                  <v-icon>mdi-plus</v-icon>
                </span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      roles: [],
      monitoring: {},
      types: ["Teks", "Angka", "Pilihan"],
      jumlahAtribut: 1,
      arrayAtribut: [],
      defAtribut: {
        nama: null
      }
    };
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      if (obj) {
        this.jumlahAtribut = obj.default_value.length;
        this.arrayAtribut = obj.default_value;
      } else {
        this.jumlahAtribut = 1;
        this.arrayAtribut = [];
      }
      this.$validator.reset();
      this.monitoring = obj ? { ...obj } : { ...this.defAtribut };
      return this.$refs.dlg.open();
    },
    add() {
      this.jumlahAtribut += 1;
    },
    remove(index) {
      this.jumlahAtribut -= 1;
      this.arrayAtribut.splice(index, 1);
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.monitoring.tipe == "Pilihan"
            ? (this.monitoring.default_value = this.arrayAtribut)
            : (this.monitoring.default_value = this.monitoring.default_value);
          return this.$store.dispatch("monitoring/form", this.monitoring);
        })
        .then(res => {
          this.$info("Simpan Data Berhasil");
          this.$refs.dlg.resolve();
          this.$router.push({ name: "monitoring" });
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
